/**
 * Format a date to DD.MM.YYYY HH:mm format (24-hour)
 */
export function formatDateTime(date?: Date | string | null): string {
  if (!date) return 'N/A';

  const d = new Date(date);
  if (isNaN(d.getTime())) return 'Invalid date';

  const day = d.getDate().toString().padStart(2, '0');
  const month = (d.getMonth() + 1).toString().padStart(2, '0');
  const year = d.getFullYear();
  const hours = d.getHours().toString().padStart(2, '0');
  const minutes = d.getMinutes().toString().padStart(2, '0');

  return `${day}.${month}.${year} ${hours}:${minutes}`;
}

/**
 * Format a date to DD.MM.YYYY format (date only)
 */
export function formatDate(date?: Date | string | null): string {
  if (!date) return 'N/A';

  const d = new Date(date);
  if (isNaN(d.getTime())) return 'Invalid date';

  const day = d.getDate().toString().padStart(2, '0');
  const month = (d.getMonth() + 1).toString().padStart(2, '0');
  const year = d.getFullYear();

  return `${day}.${month}.${year}`;
}

/**
 * Format a date for file names (DD-MM-YYYY)
 */
export function formatDateForFileName(date?: Date | string | null): string {
  if (!date) {
    date = new Date();
  }

  const d = new Date(date);
  if (isNaN(d.getTime())) return 'invalid-date';

  const day = d.getDate().toString().padStart(2, '0');
  const month = (d.getMonth() + 1).toString().padStart(2, '0');
  const year = d.getFullYear();

  return `${day}-${month}-${year}`;
}
